import {useEffect,useRef,useState} from 'react';
import {Platform} from 'react-native';
import {browserNavigation,writeBrowserNavigation} from '../shared/browser-navigation.js';
import type {LocalTrackerSession,LocalSessionState} from './local-session';
export function useBrowserDeviceRestore(session:LocalTrackerSession,state:LocalSessionState){
 const web=Platform.OS==='web',done=useRef(!web),running=useRef(false),owner=useRef<string|null|undefined>(undefined);
 const [ready,setReady]=useState(!web),[revision,setRevision]=useState(0);
 useEffect(()=>{if(!web)return;const pop=()=>{done.current=false;setReady(false);setRevision(v=>v+1);};window.addEventListener('popstate',pop);return()=>window.removeEventListener('popstate',pop);},[web]);
 useEffect(()=>{
  if(!web||!state.signedIn||state.busy||!state.snapshot||running.current)return;
  if(!state.snapshot.device){done.current=true;setReady(true);return;}
  if(owner.current!==state.accountEmail){done.current=false;owner.current=state.accountEmail;}
  if(done.current)return;
  const nav=browserNavigation(),account=state.accountEmail,device=state.snapshot.device;
  const previousOwner=window.history.state?.qtrackerOwner;
  if(nav.invalid||(previousOwner&&previousOwner!==account)){
   writeBrowserNavigation({view:'overview',device:device.id},account,true);done.current=true;setReady(true);return;
  }
  if(nav.device&&nav.device!==device.id){running.current=true;void session.selectDevice(nav.device,true).then(async ok=>{
   if(session.getSnapshot().accountEmail!==account){running.current=false;return;}
   if(!ok){await session.selectDevice(device.id,true);writeBrowserNavigation({view:'overview',device:session.selectedTrackerId},account,true);}
   running.current=false;
   done.current=true;setReady(true);
  });}else{done.current=true;setReady(true);}
 },[web,state.signedIn,state.busy,state.accountEmail,state.snapshot?.device?.id,revision,session]);
 return ready;
}
export function useBrowserPageQuery(owner:string|null|undefined){
 const [query,setQuery]=useState(browserNavigation);
 useEffect(()=>{if(Platform.OS!=='web')return;const pop=()=>setQuery(browserNavigation());window.addEventListener('popstate',pop);return()=>window.removeEventListener('popstate',pop);},[]);
 const update=(patch:{start?:string;end?:string;filter?:string;basis?:string})=>{if(Platform.OS!=='web')return;const next={...browserNavigation(),...patch};writeBrowserNavigation(next,owner);setQuery(next);};
 return [query,update] as const;
}
